import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ content }) {
  const items = content.testimonials || [];
  return (
    <section id="testimonials" className="py-24 md:py-32 bg-neutral-50" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-sm uppercase tracking-widest text-orange-600 mb-4 font-medium">
              — Client stories
            </div>
            <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-4xl sm:text-5xl md:text-6xl text-neutral-950">
              Trusted by <br /> homeowners across NY.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {items.map((t, i) => (
            <motion.div
              key={t.id || i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative bg-white border border-neutral-200 p-8 md:p-10 flex flex-col"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="w-8 h-8 text-orange-600 mb-4" />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating || 5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-orange-500 text-orange-500" />
                ))}
              </div>
              <p className="text-neutral-700 leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-8 border-t border-neutral-200 pt-5">
                <div className="font-display uppercase font-bold tracking-tight text-neutral-950">
                  {t.name}
                </div>
                {t.role && <div className="text-sm text-neutral-500 mt-0.5">{t.role}</div>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
